var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticStyle:{"width":"112px"},attrs:{"disabled":_vm.disabled},on:{"click":_vm.doSend}},[_vm._v(_vm._s(_vm.disabled ? '重发(' + _vm.counting + '秒后)' : '发送验证码'))])}
var staticRenderFns = []

export { render, staticRenderFns }